import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheManagerService {
  async clearCache(): Promise<void> {
    // Limpa cache e SW (NGSW ou Workbox)
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
}
